export default "__VITE_ASSET__bae48291__"